import {
  FetchStoresResponse,
  StorePagination,
  FetchStoreResponse,
  FetchStoreStatisticResponse,
  IStore
} from 'AppTypes'

import { Store, StoreStatistic } from '@app/models'

import axios from '@utils/axios-client'

/* eslint no-debugger: "off" */
export async function fetchStores (): Promise<StorePagination> {
  const response: FetchStoresResponse = await axios.get('/api/v1/Store')
  return ({
    data: response.data.data.map((store: IStore) => new Store(store)),
    pageCount: response.data.pageCount,
    pageIndex: response.data.pageIndex,
    pageSize: response.data.pageSize,
    totalRecords: response.data.totalRecords
  })
}

export async function fetchStore (id: string): Promise<Store> {
  const response: FetchStoreResponse = await axios.get(`/api/v1/Store/${id}`)
  return new Store(response.data)
}

export async function fetchStoreStatistic (id: string): Promise<StoreStatistic> {
  const response: FetchStoreStatisticResponse = await axios.get(`/api/v1/StoreStatistic?Id=${id}`)
  return new StoreStatistic(response.data.data)
}

// export async function searchForStores ()
